<script>
  import SettingsLayout from '../../components/SettingsLayout.svelte';
  import { onMount } from 'svelte';
  import { settingsStore } from '../../stores/settingsStore.js';

  const {
    subscriptionData,
    subscriptionLoading,
    subscriptionError,
    subscriptionMessage,
    selectedPlan,
    subscribing,
    handleSubscribe,
    openCustomerPortal
  } = settingsStore;

  onMount(() => {
    const params = new URLSearchParams(window.location.search);
    const planParam = params.get('plan');
    const subResult = params.get('subscription');

    if (planParam && ['standard', 'plus'].includes(planParam)) {
      selectedPlan.set(planParam);
    }
    if (subResult === 'success') {
      subscriptionMessage.set('Subscription activated successfully!');
    } else if (subResult === 'cancelled') {
      subscriptionMessage.set('Checkout was cancelled. You can subscribe at any time.');
    }
  });
</script>

<SettingsLayout activeTab="subscription" tabTitle="Subscription & Billing">
  <div class="p-5 border border-gray-200 rounded-lg bg-gray-50">
    {#if $subscriptionMessage}
      <div class="mb-4 p-3 rounded {$subscriptionMessage.includes('success') ? 'bg-green-100 text-green-800 border border-green-300' : 'bg-yellow-100 text-yellow-800 border border-yellow-300'}">
        {$subscriptionMessage}
      </div>
    {/if}

    {#if $subscriptionLoading}
      <div class="flex items-center py-2">
        <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-600"></div>
        <span class="ml-2 text-sm text-gray-600">Loading subscription status...</span>
      </div>
    {:else if $subscriptionError}
      <p class="text-sm text-red-600">{$subscriptionError}</p>
    {:else if $subscriptionData}
      {#if $subscriptionData.coveredByOrganisation}
        <div>
          <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">Active</span>
          <p class="mt-2 text-sm text-gray-700">
            Covered by the {$subscriptionData.orgName || 'organisation'} subscription
            {#if $subscriptionData.plan}
              ({$subscriptionData.plan === 'plus' ? 'Plus' : 'Standard'} plan)
            {/if}.
            Billing is managed by the organisation owner.
          </p>
        </div>
      {:else if $subscriptionData.status === 'active'}
        <div class="flex items-center justify-between flex-wrap gap-3">
          <div>
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">Active</span>
            <span class="ml-2 text-sm text-gray-700">
              {$subscriptionData.plan === 'plus' ? 'Plus' : 'Standard'} plan
              {#if $subscriptionData.currentPeriodEnd}
                &middot; Next billing: {new Date($subscriptionData.currentPeriodEnd).toLocaleDateString()}
              {/if}
            </span>
          </div>
          <button on:click={openCustomerPortal} class="text-sm text-blue-600 hover:text-blue-800 font-medium">
            Manage Subscription
          </button>
        </div>
      {:else if $subscriptionData.isPerpetualTrial}
        <p class="text-sm text-gray-600">You're on a free trial. No action needed.</p>
      {:else if $subscriptionData.status === 'trial' && $subscriptionData.trialDaysRemaining !== null}
        <div>
          <p class="text-sm text-orange-600 font-medium mb-3">
            Your trial ends in {$subscriptionData.trialDaysRemaining} day{$subscriptionData.trialDaysRemaining !== 1 ? 's' : ''}.
            Subscribe to continue using Buildzilla.
          </p>
          <div class="flex items-center gap-3 flex-wrap">
            <select bind:value={$selectedPlan} class="form-select rounded-md border-gray-300 text-sm py-1.5 px-3">
              <option value={null} disabled>Select a plan</option>
              <option value="standard">Standard - $40/mo</option>
              <option value="plus">Plus - $59/mo</option>
            </select>
            <button
              on:click={handleSubscribe}
              disabled={!$selectedPlan || $subscribing}
              class="px-4 py-1.5 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {$subscribing ? 'Redirecting...' : 'Subscribe'}
            </button>
            <a href="/pricing" class="text-sm text-blue-600 hover:text-blue-800">View plan details</a>
          </div>
        </div>
      {:else if $subscriptionData.status === 'expired' || $subscriptionData.status === 'past_due' || $subscriptionData.status === 'cancelled'}
        <div>
          <p class="text-sm text-red-600 font-medium mb-3">
            {#if $subscriptionData.status === 'past_due'}
              Your payment is past due. Please update your payment method.
            {:else}
              Your subscription has expired. Subscribe to regain access.
            {/if}
          </p>
          <div class="flex items-center gap-3 flex-wrap">
            {#if $subscriptionData.stripeCustomerId}
              <button on:click={openCustomerPortal} class="px-4 py-1.5 bg-gray-600 text-white text-sm font-medium rounded-md hover:bg-gray-700">
                Update Payment
              </button>
            {/if}
            <select bind:value={$selectedPlan} class="form-select rounded-md border-gray-300 text-sm py-1.5 px-3">
              <option value={null} disabled>Select a plan</option>
              <option value="standard">Standard - $40/mo</option>
              <option value="plus">Plus - $59/mo</option>
            </select>
            <button
              on:click={handleSubscribe}
              disabled={!$selectedPlan || $subscribing}
              class="px-4 py-1.5 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {$subscribing ? 'Redirecting...' : 'Subscribe'}
            </button>
          </div>
        </div>
      {:else}
        <p class="text-sm text-gray-600">You're on a free trial.</p>
      {/if}
    {/if}
  </div>
</SettingsLayout>
